export default function ExclamationIcon({ ...props }) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="#FFE14D" />
      <path
        d="M7.08032 10.5L6.61832 4.2H9.37632L8.92832 10.5H7.08032ZM7.99032 14.112C7.24832 14.112 6.67432 13.552 6.67432 12.81C6.67432 12.068 7.24832 11.508 7.99032 11.508C8.74632 11.508 9.32032 12.068 9.32032 12.81C9.32032 13.552 8.74632 14.112 7.99032 14.112Z"
        fill="#444444"
      />
    </svg>
  )
}
